export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      lastName: '',
      username: '',
      email: '',
      password: '', // so it isnt empty
      userId: null,
      loginCode: ''
    }
  }
}